import { render, staticRenderFns } from "./o-block.vue?vue&type=template&id=3492f8bc&scoped=true"
import script from "./o-block.js?vue&type=script&lang=js&external"
export * from "./o-block.js?vue&type=script&lang=js&external"
import style0 from "./o-block.scss?vue&type=style&index=0&id=3492f8bc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3492f8bc",
  null
  
)

export default component.exports